import { Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import logger from "../../../services/logger";
import Add from "../../common/add";
import PagingAndSorting from "../../common/pagingAndSorting";
import StopsTable from "./stopsTable.page";
import stopService from "./stop.service";
import StopFormPage from "./stopForm.page";
import FormDialog from "../../common/formDialog";

class Stops extends PagingAndSorting {
  state = {
    data: [],
    sortColumn: { path: "stopNum", order: "asc" },
    confirmDialogOpen: false,
    numOfStopsDilog:false,
    pagination: { page: 0, rowsPerPage: 25, count: 0, onPageChange: this.handlePageChange, onRowsPerPageChange: this.handleRowsPerPageChange }

  };

  componentDidMount() {
    this.getStops();
  }


  onConfirmOk = async (id) => {
    try {
      await stopService.deleteById(id);
      await this.getStops();
    } catch (ex) {
      logger.error(ex);
    }
  };

  closeDialog=()=>{
    this.setState({dialogOpen:false});
    this.getStops();
  }


  getStops = async () => {
    try {
      const {data} = await stopService.getAllByRoute(this.props.routeId);
      this.setState({data});
    } catch (ex) {
      logger.error(ex);
    }
  };

 

  render() {
    const { sortColumn, data, confirmDialogOpen,dialogOpen,id  } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Grid container>
          <Grid container item xs={12} sm={12} md={12} lg={12}>
            <Grid container item sm={12} md={12} direction="row-reverse">
              <Add link={"stops/new"} title={t("Add Stop")} />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <StopsTable
              data={data}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              onDelete={this.handleDelete}
              onEdit={this.handleEdit}
              t={t}
            />
          </Grid>
        </Grid>
        {
          dialogOpen &&
          <FormDialog
            title={t("Stop Details")}
            content={<StopFormPage id={id} onSave={this.closeDialog}/>}
            open={dialogOpen}
            onClose={()=>this.setState({dialogOpen:false})}
            

          ></FormDialog>
        }
        {confirmDialogOpen && this.renderDeleteConfirmDialog(
          "Delete Confirmation",
          "Are you sure you want to delete?"
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation(["stop", "common"])(Stops);
